import React from 'react';
import { FlagIcon, FlameIcon } from './icons/CustomIcons';
export function BookInfo() {
  return <div className="w-full py-16 px-4 md:px-8 lg:px-16 bg-white" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <div className="flex items-center justify-center mb-8" data-id="element-14">
          <div className="h-0.5 w-12 bg-red-700" data-id="element-15"></div>
          <h2 className="text-3xl font-bold text-center mx-4 text-[#0c2340]" data-id="element-16">
            About The Book
          </h2>
          <div className="h-0.5 w-12 bg-red-700" data-id="element-17"></div>
        </div>
        <p className="text-lg mb-6 leading-relaxed" data-id="element-18">
          In a time when voices of faith and freedom are ridiculed, censored,
          and pushed to the margins… one man chose to stand tall.
        </p>
        <p className="text-lg mb-6 leading-relaxed" data-id="element-19">
          <span className="font-bold" data-id="element-20">Unshakable Conviction</span> takes you
          behind the headlines and into the life of a leader who refused to bow,
          who carried the weight of an entire movement on his shoulders, and who
          lit a fire in the hearts of millions.
        </p>
        <div className="flex justify-center my-8" data-id="element-21">
          <div className="h-0.5 w-24 bg-gray-300" data-id="element-22"></div>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#0c2340] mb-8" data-id="element-23">
          <p className="text-lg italic" data-id="element-24">
            "This isn't just a story. It's a warning. It's a call to action. And
            it's proof that one person, standing firm, can spark a revolution of
            hope."
          </p>
        </div>
        <p className="text-lg mb-6 leading-relaxed" data-id="element-25">
          You've seen the chaos in our country. You've felt the frustration of
          watching America drift from its values. And you've wondered if the
          next generation will carry the torch.
        </p>
        <p className="text-lg font-bold mb-6 leading-relaxed" data-id="element-26">
          This book answers that fear with resounding clarity.
        </p>
        <div className="flex items-center justify-center gap-4 mt-10" data-id="element-27">
          <FlagIcon className="w-8 h-8 text-red-700" data-id="element-28" />
          <h3 className="text-xl font-bold text-[#0c2340]" data-id="element-29">
            Stand for Truth. Stand for America.
          </h3>
          <FlameIcon className="w-8 h-8 text-red-700" data-id="element-30" />
        </div>
      </div>
    </div>;
}